export const environment = {
  production: false,
  apiUrl: 'https://service.360redfin.com/api/v1',
  geocoding: {
    apiUrl: 'https://api.opencagedata.com',
    apiKey: 'cc0f19516e3e4273981223bb7a54114f',
  },
};
